module.exports = __webpack_public_path__ + "img/transformer.63cc1141.png";